import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Button, Img, Text } from "components";
import { TopHeader } from "components/Header/TopHeader";
import { NavMenu } from "components/Header/NavMenu";
import {
  addDeleteGetLocalStorage,
  checkoutStorageKeys,
  storageKeys,
} from "../../utils/global/localData";
/**custom modules*/
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import * as CUSTOM from "../../utils/helper/custom";
import * as API from "../../utils/helper/Enum";
import { getAuth } from "../../redux/reducers/loginData";
import { useTranslation } from "react-i18next";
import { changeTrigger, currentTrigger } from "redux/reducers/trigger";
import { getDefaultLanguage } from "../../utils/helper/custom";
import { toggleHamburger } from "redux/reducers/uiSlice";
import { useAppFont } from "../../utils/helper/useAppFont";
const Header = (props) => {
  let cpage = useLocation();
  const dispatch = useDispatch();
  const triggerValue = useSelector(currentTrigger);
  const guestId = CUSTOM.getDeviceID();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const auth = useSelector(getAuth);
  const [hamburger, setHamburger] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [cartData, setCartData] = useState(null);
  const [activeIcon, setActiveIcon] = useState(false);
  const [language, setLanguage] = useState(false);
  const hamburgerOpen = useSelector((state) => state.ui.hamburgerOpen);
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  const loginData = CUSTOM.loginData();

  const isLoggedIn = !!loginData?.id;
  const userName = loginData?.firstName || "";

  // Dynamic user data
  const userFullName = loginData?.name || auth?.name || "";
  const userMobile = loginData?.mobile || auth?.mobile || "";
  const userInitials = userFullName ? userFullName.substring(0, 2).toUpperCase() : (userName ? userName.substring(0, 2).toUpperCase() : "RA");

  const handleLogout = () => {
    localStorage.removeItem(storageKeys.USER_TOKEN);
    localStorage.removeItem(storageKeys.DEVICE_ID);
  
    localStorage.removeItem(storageKeys.CART_DATA);
    localStorage.removeItem(storageKeys.CART_COUNTER);
    localStorage.removeItem(checkoutStorageKeys.DELIVERY_DETAILS);
  
    // Custom cake data clear
    localStorage.removeItem("custom_cake_completed");
    localStorage.removeItem("custom_cake_images");
    localStorage.removeItem("custom_cake_message");
    localStorage.removeItem("custom_cake_price");
    localStorage.removeItem("custom_cake_quantities");
    localStorage.removeItem("custom_cake_reference");
    localStorage.removeItem("custom_cake_selected");
    localStorage.removeItem("custom_cake_step");
    localStorage.removeItem("custom_cake_text");
    localStorage.removeItem("custom_cake_shape");
  
    dispatch(changeTrigger("loggedout"));
    window.location.href = "/";
  };

  /**
   * Dropdown menu
   */
  const handlehamburger = () => {
    setHamburger(!hamburger);
    dispatch(toggleHamburger());
    if (!hamburger) {
      document.body.classList.add("overflow-hidden");
      document.getElementById("header-box").classList.add("relative");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.getElementById("header-box").classList.remove("relative");
      document.getElementById("header-box").classList.remove("relative");
    }
  };

  const handlelanguage = () => {
    setLanguage(!language);
  };

  const enStyles = !language ? "hidden" : "block";

  /**
   * get cart count
   */
  const getCartCount = async () => {
    try {
      const authData = CUSTOM.loginData();
      const params = { user_id: authData?.id, guest_id: guestId };
      const { data } =
        (await globalRequest(
          API?.CART?.GET_CART_COUNT,
          "get",
          {},
          { params },
          true,
        )) || {};
      if (data?.status == "SUCCESS") {
        setCartCount(data?.data?.cartCount);
      }
    } catch (error) {
      console.error("Error in getCartCount:", error);
    }
  };

  // Example usage:
  // await getCartCount();

  /**
   * get cart data
   */
  const getCartData = async () => {
    try {
      dispatch(changeLoader(true));
      const authData = CUSTOM.loginData();
      const params = { user_id: authData?.id, guest_id: guestId };
      const { data } =
        (await globalRequest(
          API?.CART?.GET_CART_DATA,
          "get",
          {},
          { params },
          true,
        )) || {};
      if (data?.status === "SUCCESS") {
        let existingCart =
          addDeleteGetLocalStorage(storageKeys?.CART_DATA, {}, "get") || [];
        if (!Array.isArray(existingCart)) {
          existingCart = [];
        }
        const updatedCart = data?.data?.cartItems?.map((item) => {
          const oldItem = existingCart.find((i) => i.id === item.id);
          return {
            ...item,
            addedAt: oldItem?.addedAt || item.addedAt || Date.now(),
          };
        });

        addDeleteGetLocalStorage(
          storageKeys?.CART_DATA,
          updatedCart,
          "add",
          "single",
        );
        setCartData(updatedCart);
      } else {
        addDeleteGetLocalStorage(storageKeys?.CART_DATA, {}, "delete");
      }
      dispatch(changeTrigger("loadCartData"));
    } catch (error) {
      addDeleteGetLocalStorage(storageKeys?.CART_DATA, {}, "delete");
      dispatch(changeTrigger("loadCartData"));
    } finally {
      dispatch(changeLoader(false));
    }
  };

  const handleCartClick = () => {
    cartData?.length > 0 &&
      CUSTOM.trackInitiateCheckout({
        value: cartData.reduce(
          (total, item) =>
            total + (item.productUom?.sellingPrice || 0) * (item.quantity || 1),
          0,
        ),
        items: cartData.length,
      });
    navigate("/cart");
  };

  useEffect(() => {
    let loginDatas = ["fetchCartCount", "loggedin"];
    if (loginDatas.includes(triggerValue)) {
      getCartData();
      getCartCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerValue]);

  useEffect(() => {
    getCartData();
    getCartCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let loginDatas = [
      "updateinlocal",
      "updateinlocal_langChg",
      "fetchCartCount",
      "loadSummay",
      "loadCartData",
      "loadAddressList",
      "loadGiftOccasionList",
      "loadAddressList",
    ];
    if (loginDatas.includes(triggerValue)) {
      setTimeout(() => {
        dispatch(changeTrigger(""));
      }, [500]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerValue]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, [500]);
  }, [cpage]);

  /**
   * class set for menu
   */
  const hamburgerStyles = !hamburger ? "" : "is-active";
  const navStyles = !hamburger
    ? "sm:hidden"
    : "sm:flex absolute flex-col items-start bg-white z-[99999] right-0 top-full sm:w-screen bg-white-A700 overflow-auto header-height-xs p-4";

  return (
    <>
      <header
        id="header-box"
        className={`sticky top-0 z-30 bg-white-A700 flex flex-row font-nunitomedium  items-center justify-center shadow-bs w-full border border-bottom border-[#e6e6e6]`}
      >
        <div className="relative flex flex-row py-2 items-center sm:gap-2 gap-2 w-full justify-center sm:justify-between sm:mx-2 mx-0 top-2">
          {/* {cpage?.pathname != "/cart" ? ( */}
          <>
            <Img
              className="h-[6%] sm:h-[10%] sm:w-[15%] w-[8%]  cursor-pointer"
              src="/images/logo.svg"
              alt="rabbitholelogo"
              onClick={() => navigate("/")}
            />
            <NavMenu
              handlehamburger={handlehamburger}
              navStyles={`${navStyles}`}
            />
            <div className="flex flex-row items-center sm:justify-between justify-end sm:mx-0 sm:gap-4 gap-2 mx-4 py-2">
              <span
                onClick={() => {
                  setActiveIcon(true);
                  handlelanguage();
                }}
                className={`
                      cursor-pointer
                      flex items-center justify-center
                      sm:w-10 sm:h-10
                      w-10 h-10
                      rounded-full
                      sm:rounded-full
                    
                      transition-all duration-200
                      hover:bg-[#FCEDF3] hover:border hover:border-[#771237] text-[#771237]

                      ${
                        activeIcon
                    ? "bg-[#FCEDF3]  border border-[#771237] text-[#771237]"
                    : "sm:border-transparent"
                  }
                    `}
              >
                <Img
                  className="h-6 w-6"
                  src="/images/new-globe.svg"
                  alt="search"
                />
                <div
                  className=" text-black-900 text-sm cursor-pointer mt-[2px] relative"
                  size="txtnunitoRegular14Black900"
                  onClick={handlelanguage}
                >
                  <div
                    className={`${enStyles} absolute left-auto top-[30px] -right-10 z-50 before-click`}
                  >
                    <div className="w-auto flex flex-row bg-white-A700 shadow-md mx-auto">
                      <div className="flex flex-col py-2 w-full">
                        <ul className="flex flex-col">
                          <li
                            className="flex items-center gap-2 px-4 py-2 text-black-900 hover:bg-gray-50_02 hover:text-pink-800"
                            onClick={(e) => {
                              localStorage.setItem(
                                "jsahdjkanbn",
                                "sd542s3ad2sa1d3iu748923DSF"
                              );
                              i18n.changeLanguage("en");
                              let defaultLanguage = "ltr";
                              document.documentElement.setAttribute(
                                "dir",
                                defaultLanguage
                              );
                              if (props?.cpage == "/cart") {
                                dispatch(changeTrigger("updateinlocal_langChg"));
                              }
                              setTimeout(() => {
                                if (props?.cpage == "/cart") {
                                  const url = new URL(window.location.href);
                                  url.searchParams.set("lang", "1");
                                  window.history.pushState(
                                    {},
                                    "",
                                    url.toString()
                                  );
                                }
                                window.location.reload();
                              }, 500);
                            }}
                          >
                            <Img
                              className="h-6 object-contain w-6 min-w-[1.5rem]"
                              src="/images/flag-eng.svg"
                              alt="rabbitholelogo"
                            />
                            <Text className="whitespace-nowrap font-nunitoregular font-normal text-base leading-6 -mt-1 self-center">
                              English
                            </Text>
                          </li>
                          <li
                            className="flex items-center gap-2 px-4 py-2 text-black-900 hover:bg-gray-50_02 hover:text-pink-800"
                            onClick={(e) => {
                              localStorage.setItem(
                                "jsahdjkanbn",
                                "sd5s42s3ad2sa1d3iu748923DSF"
                              );
                              i18n.changeLanguage("ar");
                              let defaultLanguage = "rtl";
                              document.documentElement.setAttribute(
                                "dir",
                                defaultLanguage
                              );
                              if (props?.cpage == "/cart") {
                                dispatch(changeTrigger("updateinlocal_langChg"));
                              }
                              setTimeout(() => {
                                if (props?.cpage == "/cart") {
                                  const url = new URL(window.location.href);
                                  url.searchParams.set("lang", "1");
                                  window.history.pushState(
                                    {},
                                    "",
                                    url.toString()
                                  );
                                }
                                window.location.reload();
                              }, 500);
                            }}
                          >
                            <Img
                              className="h-6 object-contain w-6 min-w-[1.5rem]"
                              src="/images/flag-arb.svg"
                              alt="rabbitholelogo"
                            />
                            <Text className="whitespace-nowrap font-nunitoregular font-normal	text-base leading-6 -mt-1 self-center">
                              عربي
                            </Text>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </span>

              <Img
                className="h-6 w-6 cursor-pointer   hover:text-[#771237]  "
                src="/images/img_search.svg"
                alt="search"
                onClick={() => navigate("/search")}
              />

              <div className="relative inline-block">
                <Img
                  className="h-6 w-6 cursor-pointer   hover:text-[#771237]"
                  src="/images/new-cart.svg"
                  alt="Add to cart"
                  onClick={(e) => {
                    e.preventDefault();
                        navigate("/cart")}}
                />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-[#FDF2F6] text-white font-nunitomedium text-[11px] rounded-[10px] min-w-[18px] h-[18px] px-1 flex items-center justify-center leading-none">
                    {cartCount > 99 ? '99+' : cartCount}
                  </span>
                )}
              </div>

              {isLoggedIn && (
                <div
                  className="
                        hidden sm:flex
                        items-center justify-center
                        w-8 h-8
                        rounded-full
                        bg-pink-100
                        cursor-pointer
                        flex-shrink-0
                      "
                  onClick={handlehamburger}
                >
                  <span className={`text-[#771237] font-bold text-xs ${interClass}`}>
                    {userInitials}
                  </span>
                </div>
              )}

              <button
                className={`${hamburgerStyles} hamburger hamburger--slider hidden sm:flex`}
                type="button"
                onClick={handlehamburger}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>

              {!isLoggedIn ? (
                <Button
                  className={`
                    sm:hidden
                    flex items-center justify-center gap-[10px]
                    h-[48px]
                    border border-[#E6E6E6]
                    bg-white
                    p-2
                    rounded-full
                    text-[#1A1A1A]
                    ${headingClass} font-medium
                    text-[16px] 
                    transition-all duration-300 ease-in-out
                    hover:bg-[#1A1A1A]
                    hover:text-[#FFFFFF]
                  `}
                  onClick={() => navigate("/login")}
                >
                  {t("Signup_Login")}
                </Button>
              ) : (
                <div className="relative sm:hidden group">
                  <div
                    className={`
                        cursor-pointer
                        flex items-center gap-3
                        text-[black]
                        ${interClass}
                        font-medium
                        px-3
                        py-2
                        rounded-lg
                        hover:bg-gray-50
                        transition-all
                      `}
                  >
                    <div className="w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center">
                      <span className={`text-pink-600 font-semibold text-xs ${interClass}`}>
                        {userInitials}
                      </span>
                    </div>
                    <span className="text-[14px]">
                      {userName}
                    </span>
                    <svg
                      className="w-4 h-4 transition-transform group-hover:rotate-180"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>

                  {/* Dropdown Menu */}
                  <div
                    className="
                        absolute
                        right-0
                        top-full
                        mt-2
                        w-[240px]
                        bg-white
                        border
                        border-gray-200
                        rounded-lg
                        shadow-2xl
                        opacity-0
                        invisible
                        group-hover:opacity-100
                        group-hover:visible
                        transition-all
                        duration-200
                        z-[9999]
                      "
                    style={{
                      backgroundColor: '#ffffff',
                      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)'
                    }}
                  >
                    {/* User Info Section */}
                    <div className="px-4 py-3 border-b border-gray-200">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center">
                          <span className="text-pink-600 font-semibold text-sm">
                            {loginData?.name ? loginData.name.substring(0, 2).toUpperCase() : "RA"}
                          </span>
                        </div>
                        <div className="flex-1">
                          <h3 className={`text-[14px] font-semibold text-gray-900 leading-tight ${interClass}`}>
                            {userName}
                          </h3>
                          <p className={`text-[12px] text-gray-500 mt-0.5 ${interClass}`}>
                            {loginData?.mobile || "+966 557 077 405"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Menu Items */}
                    <div className="py-2">
                      {/* Account Section */}
                      <div className="mb-3">
                        <div className="px-4 mb-1">
                          <h4 className={`text-[11px] font-semibold text-gray-400 uppercase tracking-wide ${interClass}`}>
                            {t("myAccount")}
                          </h4>
                        </div>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "0", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_cart_black_900.svg" className="w-4 h-4 opacity-60" alt="Orders" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("myOrders")}</span>
                        </button>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "7", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/Wishlist.svg" className="w-4 h-4 opacity-60" alt="Orders" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("wishlist")}</span>
                        </button>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "5", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_computer_black_900_28x28.svg" className="w-4 h-4 opacity-60" alt="Custom Cakes" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("myCustomCakes")}</span>
                        </button>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "1", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_volume_black_900.svg" className="w-4 h-4 opacity-60" alt="Occasions" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("myOccasions")}</span>
                        </button>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "2", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_location.svg" className="w-4 h-4 opacity-60" alt="Addresses" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("myAddresses")}</span>
                        </button>
                      </div>

                      {/* Payments Section */}
                      <div className="mb-3">
                        <div className="px-4 mb-1">
                          <h4 className={`text-[11px] font-semibold text-gray-400 uppercase tracking-wide ${interClass}`}>
                            {t("payment")}
                          </h4>
                        </div>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "3", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_wallet.svg" className="w-4 h-4 opacity-60" alt="Wallet" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("wallet")}</span>
                        </button>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "4", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_payment-menthod.svg" className="w-4 h-4 opacity-60" alt="Payment Methods" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("managePaymentMenthods")}</span>
                        </button>
                      </div>

                      {/* Settings Section */}
                      <div>
                        <div className="px-4 mb-1">
                          <h4 className={`text-[11px] font-semibold text-gray-400 uppercase tracking-wide ${interClass}`}>
                            {t("settings")}
                          </h4>
                        </div>
                        <button
                          onClick={() => {
                            navigate("/my-order");
                            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, "6", "add", "single");
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 hover:bg-pink-50 transition-all"
                        >
                          <Img src="/images/img_bluetooth.svg" className="w-4 h-4 opacity-60" alt="Language" />
                          <span className={`text-[13px] font-medium text-gray-700 ${interClass}`}>{t("preferredLanguage")}</span>
                        </button>
                      </div>
                    </div>

                    {/* Logout Button */}
                    <div className="border-t border-gray-200 p-2">
                      <button
                        onClick={handleLogout}
                        className={`
                            w-full
                            flex items-center gap-3
                            px-4
                            py-2
                            text-[14px]
                            font-medium
                            text-[#771237]
                            hover:bg-[#FCEDF3]
                            rounded-lg
                            transition-all
                            ${interClass}
                          `}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        {t("Logout")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
          {/* // ) : null} */}
        </div>
      </header>
      <Outlet />
    </>
  );
};

Header.defaultProps = {};

export default Header;
